import React, { useState, useEffect } from 'react';
import { checkOnboardingStatus } from "../../apis/operator";
import SelectComponent from "../../ReusableComponents/SelectComponent";
import { Button } from "../Helper";
import { getAllCrops } from "../../apis/crops";

const AddCropForm = React.forwardRef(({ onNext }, ref) => {
    const[existingLocation, setExistingLocation] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [allCrops, setAllCrops] = useState([]);   // keep original crops from API
    const [cropsOptions, setCropsOptions] = useState([]);
    const[crops,setCrops]=useState([]);
    const [newCrop, setNewCrop] = useState({
        crop_name: "",
        cost: "",
        crop_id: "",
    });

const validateForm = () => {
  if (crops.length === 0) {
    setError('Please select at least one crop.');
    return false;
  } else {
    setError('');
    return true;
  }
};

      const getOnBoardingStatusFunc = async () => {
        try {
          const data = await checkOnboardingStatus();
          if (data.existingLocation){
            setExistingLocation(data.existingLocation);
          }   
        } catch (err) {
          console.log("Error fetching onboarding status", err);
        }
      };

      const getCropsFunc = async () => {
        try{
         const cropsRes = await getAllCrops()
                   const cropsOptions = cropsRes?.crops?.map((crop) => ({
                       label: crop.name,
                       value: crop.id,
                   }))
            setAllCrops(cropsOptions);    // store original list
        setCropsOptions(cropsOptions); // initially, same as original
         setLoading(false)
        }catch(err){
            console.log("Error fetching crops", err);
            setLoading(false);
        }
      }

      React.useImperativeHandle(ref, () => ({
  submitForm: () => {
    if (validateForm()) {
      onNext(crops);
    } else {
      onNext(null);
    }
  },
}));

      

       useEffect(() => {
        const addedIds = crops.map(c => c.crop_id);
        const filtered = allCrops.filter(crop => !addedIds.includes(crop.value));
        setCropsOptions(filtered);
      }, [crops, allCrops]);

    
        useEffect(()=>{
         getCropsFunc();
         getOnBoardingStatusFunc();
        },[]);
  return (
    <div className="flex flex-col h-[100%] gap-5 ">
          <div style={{ display: "flex", gap: "0.2rem", flexDirection: "column" }}>
            <div>
              <p className="form-title" style={{ marginBottom: "0px" }}>
                Add Crop
              </p>
            </div>
            <span className="font-manrope text-[11px] font-[500] tracking-wide">
              This crop and price will be applicable for <span className="text-blue-600">{existingLocation?.address}</span> You can add more crops and location from crops & pricing and location section
            </span>
          </div>
          <div className="font-manrope font-[700]">Add a crop and their prize to start your business.</div>

        <div className="flex flex-col gap-3 ">
          <div className="flex w-full gap-4 items-center ">
            <div className="w-[40%]">
             <SelectComponent
                      controlStyle={{ 
                        width: "100%", 
                        height: "34px",
                        borderRadius: "4px", 
                        border: "1px solid #D9D9D9", 
                        background: "white", 
                        fontSize: "11px",
                        outline: "none !important",
                        fontWeight: "500",
                        color: "#1E1E1E",
                        boxShadow: "none"
                    }}
                    isDisabled={false}
                      isSearchable={true}
                      placeholder={"Select crop"}
                      menuPlacement={"bottom"}
                      list={cropsOptions}
                     value={newCrop?.crop_id ? { value: newCrop.crop_id, label: newCrop.crop_name } : null}
                       onChange={(selectedCrop) => {
                                            setNewCrop((prev) => ({
                                                ...prev,
                                                crop_id: selectedCrop.value,
                                                crop_name: selectedCrop.label,
                                            }))
                                        }}
                  />

            </div>

             <input
            type="text"
            id="last_name"
            name="last_name"
             value={newCrop.cost}
            placeholder={"Spraying price(per acre)"}
            onChange={(e)=>{
               let value = e.target.value;
                value = value.replace(/[^\d]/g, '')
                if (value === '' || parseInt(value) >= 1) {
                    setNewCrop((prev) => ({
                        ...prev,
                        cost: value
                    }));
                }
            }}
            required
            style={{
              width: "40%",
              height: "34px",
              padding: "8px 12px",
              borderRadius: "4px",
              border: "1px solid #D9D9D9",
              fontSize: "12px",
              outline: "none",
              boxSizing: "border-box",
            }}
          />

          <button
          disabled={!newCrop.crop_name || !newCrop.cost}
          onClick={(e) => {
            e.preventDefault();
            setCrops((prev) => ([...prev, newCrop]))
            setNewCrop((prev) => ({
                ...prev,
                crop_id: "",
                crop_name: "",
                cost:"",
            }))
            setError('');
        }}
           className={`w-[10%] bg-[#1E1E1E] ${(!newCrop.crop_name || !newCrop.cost)?"opacity-60 cursor-not-allowed":" cursor-pointer"}  text-white h-[40px] rounded-[8px] text-[13px] `}>
            Add Crop 
          </button>

          </div>
          {error && (
  <div className="text-red-500 text-xs font-medium mt-1">{error}</div>
)}

          </div>
          <div className="flex flex-wrap gap-2 mt-2">
  {crops.map((crop, index) => (
    <div
      key={index}
      className="flex items-center bg-[#EDEDED] text-[#000000] rounded-full px-4 py-2 text-[12px] font-medium"
      style={{ maxWidth: "100%" }}
    >
      <span className="truncate">{crop.crop_name} ({crop.cost})</span>
      <button
        onClick={() =>
          setCrops((prev) => prev.filter((_, i) => i !== index))
        }
        className="ml-1 text-[#000000]"
        style={{ fontWeight: "bold", fontSize: "12px" }}
      >
        ✕
      </button>
    </div>
  ))}
</div>

        </div>
  );
})

export default AddCropForm;